/**
 * Anlamsal renkler (good / warn / bad) markanın turuncusundan ayrıdır;
 * turuncu vurgu rengidir, durum rengi değildir.
 *
 * Berry paletindeki warning.main çok açık bir sarı olduğu için metin
 * üzerinde okunmuyor; burada kendi eşdeğerlerini tanımlıyoruz.
 */
const LIGHT = {
  good: { text: '#2E7D32', bg: '#E7F3E8' },
  warn: { text: '#B26A00', bg: '#FDF0DC' },
  bad: { text: '#C62828', bg: '#FBEAEA' },
  empty: { text: '#78909C', bg: '#ECEFF1' }
};

const DARK = {
  good: { text: '#66BB6A', bg: 'rgba(102,187,106,.16)' },
  warn: { text: '#FFB74D', bg: 'rgba(255,183,77,.16)' },
  bad: { text: '#EF5350', bg: 'rgba(239,83,80,.16)' },
  empty: { text: '#8492C4', bg: 'rgba(132,146,196,.16)' }
};

export const getLevelColor = (theme, level) =>
  (theme.palette.mode === 'dark' ? DARK : LIGHT)[level] || LIGHT.empty;

/** Grafiklerde seri renkleri — vurgu turuncusundan türetilmiş sıralı set. */
export const getSeriesColors = (theme) =>
  theme.palette.mode === 'dark'
    ? ['#FFA726', '#FFCC80', '#8492C4', '#66BB6A', '#7C4DFF']
    : ['#FF9800', '#FFCC80', '#78909C', '#2E7D32', '#673AB7'];
